// Lib
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { areBoardHierarchiesInitialised } from '../../app/initialisation/initialisationSelector';

// Monitoring
import workspaceInitialisationMonitoringSingleton from './workspaceInitialisationMonitoringSingleton';

const mapStateToProps = createStructuredSelector({ areBoardHierarchiesInitialised });

interface WorkspaceInitialisationMonitoringProps {
    areBoardHierarchiesInitialised: boolean;
}

/**
 * This component has two responsibilities:
 *  - Ensure the timer for the workspace initialisation has started
 *  - Wait for the app.initialised.boardHierarchies to be initialised
 */
const WorkspaceInitialisationMonitoring = (props: WorkspaceInitialisationMonitoringProps): null => {
    const { areBoardHierarchiesInitialised } = props;

    // On workspace load, ensure the timer is initialised
    React.useEffect(() => {
        workspaceInitialisationMonitoringSingleton.initialiseTimer();
    }, []);

    // When board hierarchies are initialised, the activity indicators will also be initialised
    React.useEffect(() => {
        if (!areBoardHierarchiesInitialised) return;

        workspaceInitialisationMonitoringSingleton.setActivityIndicatorsInitialised();
    }, [areBoardHierarchiesInitialised]);

    return null;
};

export default connect(mapStateToProps)(WorkspaceInitialisationMonitoring);
